import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=169348a6&scoped=true&"
import script from "./LayoutFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFooter.vue?vue&type=style&index=0&id=169348a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169348a6",
  null
  
)

export default component.exports